import { Form, Input} from 'antd';
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import FormItem from 'antd/es/form/FormItem';
import './AddBilling.css';
import useAccountFlow from '../../../hooks/common/useAccountFlow';
import { useBookingData } from '../../../context/BookingDataContext';

const AddBilling = ({ setUpdatedBillingDetails }) => {
  const { bookingData, setBookingData } = useBookingData()
  const { accountDetails, handleAccount } = useAccountFlow();
  const [form] = Form.useForm();
  
  useEffect(() => {
    handleAccount();
  }, []);

  useEffect(() => {
    if (!bookingData?.updatedBillingDetails || !accountDetails?.customer) return;

      form.setFieldsValue({
        email: accountDetails.customer.email || '',
        customerId: accountDetails.customer.customerId || '',
      });
    
  }, [accountDetails, form, bookingData]);

  const validateEmail = (_, value) => {
    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value || emailRegex.test(value) || phoneRegex.test(value)) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('Please enter a valid email or phone number.'));
  };

  const validatePincode = (_, value) => {
    const pincodeRegex = /^[0-9]{6}$/;
    if (!value || pincodeRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Please enter a valid 6-digit pincode.'));
  };

  const handleFormChange = (_, allValues) => {
    const formattedPayload = {
      fullName: allValues.fullName || "",
      phoneNumber: allValues.phoneNumber || "",
      email: allValues.email || "",
      pincode: allValues.pincode || "",
    };

    setBookingData((prevData) => ({
      ...prevData,
      updatedBillingDetails: formattedPayload,
    }));
    setUpdatedBillingDetails(formattedPayload);
  };

  return (
    <Container className='my-5 add-billing-container' >
       <div className='pb-3 text-mob'>
            <h4 className='fs-28 fw-700 text-black'>
              Add your billing info
            </h4>
        </div>

      <Row 
        className='d-flex align-items-center justify-content-center'
        style={{ borderRadius: '24px', backgroundColor: '#FFFF', border: '1px solid #A0A1AB' }}
      >
        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='px-0'>
            <Form className='pt-4' form={form} onValuesChange={handleFormChange}  
              initialValues={{
                fullName: bookingData?.updatedBillingDetails?.fullName || '',
                phoneNumber: bookingData?.updatedBillingDetails?.phoneNumber || '',
                pincode: bookingData?.updatedBillingDetails?.pincode || '',
                email: bookingData?.updatedBillingDetails?.email || accountDetails?.customer?.email || '',
                customerId: accountDetails?.customer?.customerId || '',
              }}
            >
              <Row className='m-4 billing-form'>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <FormItem
                    name="fullName"
                    rules={[{ required: true, message: 'Please enter your full name!' }]}
                    style={{ marginBottom: '2rem' }}
                  >
                    <Input className="floating-input-billing text-black" placeholder='Full name' style={{ border: '1px solid #303136' }}/>
                  </FormItem>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <FormItem
                    name="phoneNumber"
                    rules={[
                      { required: true, message: 'Please enter a valid phone number' },
                      { validator: validateEmail },
                    ]}
                    style={{ marginBottom: '2rem' }}
                  >
                    <Input className="floating-input-billing text-black" placeholder='Phone number' style={{ border: '1px solid #303136' }}/>
                    {/* <div>
                      <Input className="floating-input" style={{ border: '1px solid #303136' }} />
                      <label className="floating-label">Phone</label>
                    </div> */}
                  </FormItem>
                </Col>

                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <FormItem
                    name="pincode"
                    rules={[{ required: true, message: 'Please enter your pincode!' }, { validator: validatePincode }]}
                    style={{ marginBottom: '2rem' }}
                  >
                      <Input className="floating-input-billing" placeholder="Pincode" style={{ border: '1px solid #303136' }} />
                  </FormItem>
                </Col>

                {accountDetails?.customer?.email ? (
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                      <FormItem name="email" style={{ marginBottom: '2rem' }}>
                      <Input className="floating-input-billing" placeholder="Email" style={{ border: '1px solid #303136' }} disabled/>
                      </FormItem>
                    </Col>
                  ) : (
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                      <FormItem
                        name="email"
                        rules={[{ required: true, message: 'Please enter correct email' }, { validator: validateEmail }]}
                        style={{ marginBottom: '2rem' }}
                      >
                        <Input className="floating-input-billing" placeholder="Email" style={{ border: '1px solid #303136' }} />
                      </FormItem>
                    </Col>
                  )}

                  {accountDetails?.customer?.customerId && (
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                      <FormItem name="customerId" style={{ marginBottom: '2rem' }}>
                        <Input className="floating-input-billing text-black" style={{ border: '1px solid #303136' }} disabled/>
                      </FormItem>
                    </Col>
                  )}
              </Row>
            </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AddBilling;
